// extracted by mini-css-extract-plugin
export default {"authLayoutFooter":"AuthLayout_authLayoutFooter__u1Q6P"};